export default "__VITE_ASSET__IwdiUV99__"